import produce from 'immer'
import { Reducer } from 'redux'

import {
  SET_SIGN_UP_MODAL_IS_OPEN,
  SET_FREE_TRIAL_REQUEST_MODAL_IS_OPEN,
  SET_USER_ROLES_MODAL_IS_OPEN,
  SET_USER_ROLES_MODAL_IS_BASIC_MESSAGE,
  SET_SHOW_SIGN_UP_MODAL_ON_CLOSE
} from 'redux/actions/types'

interface ModalsState {
  signUp: {
    isOpen: boolean;
  };
  freeTrialRequest: {
    isOpen: boolean;
    showSignUpModalOnClose: boolean;
  };
  userRole: {
    isOpen: boolean;
    isBasicMessage: boolean;
  };
}

const initialState: ModalsState = {
  signUp: { 
    isOpen: false
  },
  freeTrialRequest: { 
    isOpen: false,
    showSignUpModalOnClose: false
  },
  userRole: {
    isOpen: false,
    isBasicMessage: false
  }
}

const modals:Reducer<ModalsState, any> = (state = initialState, action) => {
  switch (action.type) {
    case SET_SIGN_UP_MODAL_IS_OPEN:
      return produce(state, draft => {
        draft.signUp.isOpen = action.isOpen
      })
    case SET_FREE_TRIAL_REQUEST_MODAL_IS_OPEN:
      return produce(state, draft => {
        draft.freeTrialRequest.isOpen = action.isOpen
      })
    case SET_USER_ROLES_MODAL_IS_OPEN:
      return produce(state, draft => {
        draft.userRole.isOpen = action.isOpen
      })
    case SET_USER_ROLES_MODAL_IS_BASIC_MESSAGE:
      return produce(state, draft => {
        draft.userRole.isBasicMessage = action.isBasicMessage
      })
    case SET_SHOW_SIGN_UP_MODAL_ON_CLOSE:
      return produce(state, draft => {
        draft.freeTrialRequest.showSignUpModalOnClose = action.showSignUpModalOnClose
      })
    default:
      return state
  }
}

export default modals
